import { IRecipientNotification } from "../../../services/admin-report-data-service/Models";

export type NotifyMeFormValuesType = {
    userRecipients: IRecipientNotification[]
};

export const defaultFormValues: NotifyMeFormValuesType = {
    userRecipients: []
};

const NotifyMeUtils = {

     mapToForm: (model: IRecipientNotification[]): NotifyMeFormValuesType => {

        const formData = {
            userRecipients: model.map(o => {
                return {...o
                } as IRecipientNotification
            })

        } as NotifyMeFormValuesType;

        return formData;
     }
};

export default NotifyMeUtils;